import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

export function IcnClose(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="close">
      <line x1="4" y1="4" x2="12" y2="12" />
      <line x1="12" y1="4" x2="4" y2="12" />
    </Svg>
  );
}
